<template>
  <div class="input-container" v-if="!activeFileSrc">
    <div class="label-title label-format-title">
      Загрузите файл до 30 МБ — PDF
    </div>
    <v-file-input
        :model-value="activeFile"
        :hide-details="true"
        :prepend-icon="false"
        :clearable="false"
        accept=".pdf,application/pdf"
        @update:model-value="value => uploadFile(value)"
    >
      <template v-slot:label>
        Загрузить файл
      </template>
      <template v-slot:append-inner>
        <icon-default color="dark-green">
          <FileUploadIcon/>
        </icon-default>
      </template>
    </v-file-input>
  </div>

  <div class="input-file-container" v-else>
    <div class="left-container">
      <icon-default size="mini" color="dark-green">
        <CopyIcon/>
      </icon-default>

      <div class="center-container">
        <div class="title-container">
          <main-title class="file-title" @click="$emit('clickFile', activeFile)">{{ fileComputed.name }}</main-title>
          <main-title class="size-title">{{ fileComputed.size }}</main-title>
        </div>
      </div>
    </div>

    <div class="right-container">
      <icon-default
          class="cross"
          @click="$emit('removeFile', activeFile)"
          color="dark-green"
          size="mini">
        <CrossIcon/>
      </icon-default>
    </div>
  </div>
</template>

<script>
import IconDefault from "@/components/shared/icons/IconDefault.vue";
import FileUploadIcon from "@/assets/icons/ui/upload.svg?inline";
import CopyIcon from "@/assets/icons/ui/copy.svg?inline";
import CrossIcon from "@/assets/icons/ui/cross.svg?inline";
import MainTitle from "@/components/shared/text/MainTitle.vue";

export default {
  name: "PdfFileInput",
  components: { IconDefault, FileUploadIcon, CopyIcon, CrossIcon, MainTitle },
  props: {
    activeFile: {
      type: Object,
      default: null
    }
  },
  computed: {
    activeFileSrc() {
      return this.activeFile?.file;
    },
    fileComputed() {
      const file = this.activeFile?.file;
      return {
        name: file?.name || "-",
        size: file ? this.convertSize(file.size) : "0 Б"
      };
    }
  },
  methods: {
    convertSize(bytes) {
      if (bytes < 1024) return `${bytes} Б`;
      if (bytes < 1024 ** 2) return `${(bytes / 1024).toFixed(2)} КБ`;
      if (bytes < 1024 ** 3) return `${(bytes / 1024 ** 2).toFixed(2)} МБ`;
      return `${(bytes / 1024 ** 3).toFixed(2)} ГБ`;
    },
    uploadFile(file) {
      if (!file) return;

      if (file.type !== "application/pdf") {
        this.alertError?.("Можно загружать только PDF-файлы!");
        return;
      }

      const maxSize = 30 * 1024 * 1024; // 30 МБ
      if (file.size > maxSize) {
        this.alertError?.("Размер файла превышает 30 МБ!");
        return;
      }

      const fileSrc = URL.createObjectURL(file);
      const fileName = file.name;

      this.$emit("changeFile", { file, fileSrc, fileName });
    }
  }
};
</script>

<style scoped lang="scss">
.input-file-img-container {
  border-radius: 8px;
  overflow: hidden;
  width: 260px;
  height: 180px;
  position: relative;

  .icon-container {
    z-index: 1;
    cursor: pointer;
    position: absolute;
    right: 8px;
    top: 8px;
  }

  & video {
    width: 100%;
    height: 100%;
  }
  & img {
    width: 100%;
    height: 100%;
  }
}
.input-file-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: rgba(var(--color-grey-rgba), 1);
  border-radius: 8px;
  padding: 10px 16px;

  .left-container {
    display: flex;
    flex-direction: row;
    column-gap: 16px;
    align-items: center;
    .center-container {
      display: flex;
      flex-direction: column;
      row-gap: 2px;
      width: 300px;

      .title-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        column-gap: 8px;

        .main-title-container {
          color: var(--color-dark-green);
          &.file-title{
            cursor: pointer;
          }
          &.size-title {
            white-space: nowrap;
            color: rgba(var(--color-ligth-green), 1)
          }
        }
      }
    }
  }
  .right-container {
    display: flex;
    flex-direction: row;
    column-gap: 8px;

    .icon-container {
      cursor: pointer;
    }
  }
}

.input-container {
  width: 100%;
  position: relative;
  height: 82px;
  cursor: pointer;

  @media(max-width: 769px) {
    height: 100px;
  }

  .label-format-title {
    padding: 0 16px;
    pointer-events: none;
    position: absolute;
    font-weight: 100;
    z-index: 900;
    top: 70%;
    transform: translate(-50%, -70%);
    left: 50%;
    font-size: 12px;
    color: rgba(var(--color-ligth-green), 1);
    text-align: center;
    width: 100%;
  }
}
.v-file-input {
  display: block;
  cursor: pointer !important;
  width: 100%;
  height: 100%;
  background: rgba(var(--color-grey-rgba), 0.4);
  border-radius: 8px;
  opacity: 1;
  border: 2px dashed rgba(var(--color-dark-green-rgb), 0.6);
  &:hover {
    background: rgba(var(--color-grey-rgba), 0.6);
    border: 2px dashed rgba(var(--color-dark-green-rgb), 0.8);
    :deep() {
      .v-label.v-field-label {
        color: var(--color-dark-green);
      }
    }
  }
  :deep() {
    font-weight: 100;
    color: var(--color-dark-green);
    .v-label.v-field-label {
      cursor: pointer;
      position: relative;
      visibility: visible !important;
      font-size: 14px !important;
      top: 30%;
      opacity: 1 !important;
      transform: scale(1) translateY(-30%) !important;
      width: fit-content !important;
      min-width: max-content;
      transition: color .3s ease;
      @media(max-width: 769px) {
        font-size: 12px !important;
      }
    }
    .v-field__input, .v-field__overlay, .v-field__loader {
      display: none;
    }
    .v-field__field {
      flex: none;
    }
    input {
      cursor: pointer;
    }
    .v-field__append-inner {
      height: 24px;
      position: relative;
      top: 30%;
      transform: translateY(-30%) !important;
    }
    .v-field {
      opacity: 1;
      display: flex;
      width: fit-content;
      justify-content: center;
      border: none;
    }
    .v-input__control {
      cursor: pointer;
      height: 100%;
    }
    .v-field__outline {
      display: none;
    }
    .v-field__field {
      width: fit-content;
    }
    .v-field--center-affix .v-label.v-field-label--floating {
      display: none;

    }
  }
}
</style>
